module.exports = __webpack_public_path__ + "img/ic_delete.0d92ee4e.svg";